import * as React from 'react';
import { Box, CircularProgress } from '@mui/material';
import Colors from '../../constants/Colors';

const StyledProgressCircle = ({ sx, ...props }) => (
    <CircularProgress style={{ color: Colors.primaryColor, ...sx }} thickness={3} {...props} />
)

export const StyledLoadingSection = () => (
    <Box sx={{ position: 'relative', minHeight: '80vh' }}>
        <Box
            sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1,
            pointerEvents: 'none', // allow clicks through
            }}
        >
            <StyledProgressCircle />
        </Box>
    </Box>
    
)

export default StyledProgressCircle;
